import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Phone } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
export function ContactSection() {
  return <section id="contact" className="py-20 bg-white" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <SectionHeading title="Contact Us" subtitle="Get in touch with our team for inquiries, support, or collaboration." data-id="element-43" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-44">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#0f5f5f] text-white p-10 rounded-2xl shadow-xl" data-id="element-45">
            <h3 className="text-2xl font-serif font-bold mb-8" data-id="element-46">
              Contact Information
            </h3>

            <div className="space-y-8" data-id="element-47">
              <div className="flex items-start space-x-4" data-id="element-48">
                <div className="bg-[#d4a74a] p-3 rounded-full text-[#0f5f5f]" data-id="element-49">
                  <MapPin size={24} data-id="element-50" />
                </div>
                <div data-id="element-51">
                  <h4 className="font-bold text-lg mb-1" data-id="element-52">Our Office</h4>
                  <p className="text-gray-300" data-id="element-53">
                    Kyiv, Ukraine
                    <br data-id="element-54" />
                    Business Center "Senator"
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-55">
                <div className="bg-[#d4a74a] p-3 rounded-full text-[#0f5f5f]" data-id="element-56">
                  <Mail size={24} data-id="element-57" />
                </div>
                <div data-id="element-58">
                  <h4 className="font-bold text-lg mb-1" data-id="element-59">Email Us</h4>
                  <p className="text-gray-300 break-all" data-id="element-60">
                    fgsukraine@gmail.com
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-61">
                <div className="bg-[#d4a74a] p-3 rounded-full text-[#0f5f5f]" data-id="element-62">
                  <Phone size={24} data-id="element-63" />
                </div>
                <div data-id="element-64">
                  <h4 className="font-bold text-lg mb-1" data-id="element-65">Call Us</h4>
                  <p className="text-gray-300" data-id="element-66">+380 (XX) XXX-XX-XX</p>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-12 border-t border-white/20" data-id="element-67">
              <h4 className="font-bold text-lg mb-4" data-id="element-68">Follow Us</h4>
              <div className="flex space-x-4" data-id="element-69">
                {/* Social Placeholders */}
                {['Facebook', 'Twitter', 'LinkedIn', 'Instagram'].map(social => <a key={social} href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#d4a74a] hover:text-[#0f5f5f] transition-all duration-300" data-id="element-70">
                      <span className="sr-only" data-id="element-71">{social}</span>
                      <span className="text-sm font-bold" data-id="element-72">{social[0]}</span>
                    </a>)}
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-73">
            <form action="mailto:fgsukraine@gmail.com" method="post" encType="text/plain" className="space-y-6" data-id="element-74">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-75">
                <div data-id="element-76">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-77">
                    Name
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0f5f5f] focus:border-transparent outline-none transition-all" placeholder="Your Name" data-id="element-78" />
                </div>
                <div data-id="element-79">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-80">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0f5f5f] focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-81" />
                </div>
              </div>

              <div data-id="element-82">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-83">
                  Subject
                </label>
                <input type="text" id="subject" name="subject" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0f5f5f] focus:border-transparent outline-none transition-all" placeholder="How can we help?" data-id="element-84" />
              </div>

              <div data-id="element-85">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-86">
                  Message
                </label>
                <textarea id="message" name="message" rows={5} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0f5f5f] focus:border-transparent outline-none transition-all resize-none" placeholder="Write your message here..." data-id="element-87"></textarea>
              </div>

              <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-88">
                Send Message
              </Button>

              <p className="text-xs text-center text-gray-500 mt-4" data-id="element-89">
                This form will open your default email client to send the
                message directly to fgsukraine@gmail.com
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}